import AuthRoute from '../AuthRoute';
import Field from '@rezdy/components/Form/Field';
import GenerateQRCode from './GenerateQRCode';
import React from 'react';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import { withTranslation } from 'react-i18next';

class SetupMFA extends AuthRoute {
    renderBody = () => {
        return (
            <React.Fragment>
                <GenerateQRCode />
                <Field label="Authentication Code" name="mfaCode">
                    <TextInput type="text" autoComplete="off" />
                </Field>
            </React.Fragment>
        );
    };
}

export default withTranslation()(SetupMFA);
